module.exports = "/images/18K-RG.webp?945219c9db469b7bc2e11121926eb061";